import { Stack, Container, Typography, Box, Tabs, Tab } from "@mui/material";
import theme from "../../../muiTheme";
import "./ConsumptionsHeader.scss";
import { useTranslation } from "react-i18next";
import {
  SelectedTabConsumptions,
  TabsDataConsumption,
} from "../../../core/models/consumptions/consumptions.model";

interface ConsumptionsHeaderProps {
  selectedTab: string;
  setSelectedTab: React.Dispatch<React.SetStateAction<SelectedTabConsumptions>>;
}

const ConsumptionsHeader = ({
  selectedTab,
  setSelectedTab,
}: ConsumptionsHeaderProps) => {
  const { t } = useTranslation();

  const tabsDataConsumption: TabsDataConsumption[] = [
    {
      id: "periodConsumption",
      value: "periodConsumption",
      label: "Consumos por periodo",
    },
    {
      id: "comparativeConsumption",
      value: "comparativeConsumption",
      label: "Comparativa",
    },
    {
      id: "download",
      value: "download",
      label: "Descargar",
    },
    
  ];

  return (
    <Box className="consumptions">
      <Stack
        direction="column"
        component="article"
        className="consumptions__header"
      >
        <Container component="div">
          <Typography variant="h1" component="h1">
            {t("Header.Nav.Consumos")}
          </Typography>
          <Box sx={{ width: "100%" }}>
            <Tabs
              className="tabs-wrapper"
              value={selectedTab}
              onChange={(
                event: React.SyntheticEvent,
                newValue: SelectedTabConsumptions
              ) => {
                setSelectedTab(newValue);
              }}
              component={"ul"}
              sx={{
                ".MuiTabs-indicator": {
                  left: 0,
                },
                paddingLeft: 0,
              }}
            >
              {tabsDataConsumption.map(({ id, label, value }) => (
                <Tab
                  key={id}
                  component="a"
                  label={
                    <Typography component="span" variant="tab">
                      {t(`Consumos.${label}`)}
                    </Typography>
                  }
                  sx={{ color: theme.palette.grey[500] }}
                  value={value}
                  className="tab"
                  disableRipple
                />
              ))}
            </Tabs>
          </Box>
        </Container>
      </Stack>
    </Box>
  );
};

export default ConsumptionsHeader;
